<template>
	<svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M39.8359 80.6406C17.8438 80.6406 -0.0078125 62.7891 -0.0078125 40.7969C-0.0078125 18.8047 17.8438 0.953125 39.8359 0.953125C61.8281 0.953125 79.6797 18.8047 79.6797 40.7969C79.6797 62.7891 61.8281 80.6406 39.8359 80.6406ZM39.8359 74C58.1953 74 73.0391 59.1562 73.0391 40.7969C73.0391 22.4375 58.1953 7.59375 39.8359 7.59375C21.4766 7.59375 6.63281 22.4375 6.63281 40.7969C6.63281 59.1562 21.4766 74 39.8359 74ZM32.5312 56.0703C30.6953 57.1641 28.625 56.2656 28.625 54.3906V27.2422C28.625 25.3281 30.8516 24.5859 32.5312 25.5625L54.7578 38.7266C56.3594 39.7031 56.3984 41.9688 54.7578 42.9062L32.5312 56.0703Z" fill="white" />
	</svg>
</template>

<script>
export default {
	name: 'PlayRounded',
};
</script>
